import { JSX } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { fCurrency } from 'src/utils/formatNumber';
import { removeInvalidDecimalPlace } from 'src/utils/normalizeInputs';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

const normalizeCurrency = (value: string): string => {
  if (!value) {
    return value;
  }
  if (value.endsWith('..')) {
    return value.slice(0, value.length - 1);
  }
  if (value.endsWith('.')) {
    return removeInvalidDecimalPlace(value);
  }
  const [amount, initialCents] = String(value).split('.');
  let cents = initialCents;
  if (cents) {
    cents = cents.replace(/[^\d]/g, '');
    if (cents.length > 2) {
      cents = cents.slice(0, 2);
    }
  }
  const currentValue = Number(String(amount).replace(/[^\d]/g, ''));
  if (Number.isInteger(currentValue)) {
    return `${fCurrency(currentValue, false)}${cents ? `.${cents}` : ''}`;
  }
  return '';
};

export default function CurrencyInput({ value, onChange }: Props): JSX.Element {
  return (
    <TextField
      fullWidth
      value={value ? normalizeCurrency(value) : ''}
      onChange={(e) => onChange(normalizeCurrency(e.target.value))}
      inputProps={{ inputMode: 'decimal', 'data-testid': 'currency-input' }}
      InputProps={{
        startAdornment: <InputAdornment position="start">$</InputAdornment>,
      }}
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
    />
  );
}
